import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import { SpinnerService } from '../../services/spinner.service';
import { ApiQuestion, ApiSetQuestionsRequest } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { MultiQnameDialogComponent } from '../../common/multi-qname-dialog/multi-qname-dialog.component';
import { MultiQcompDialogComponent } from '../../common/multi-qcomp-dialog/multi-qcomp-dialog.component';
import { MultiQitemDialogComponent } from '../../common/multi-qitem-dialog/multi-qitem-dialog.component';
import { TranslateService } from '@ngx-translate/core';

import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

export interface QuestionDialogData {
  change_type: number;
  question?: ApiQuestion;
}

@Component({
  selector: 'app-question-dialog',
  templateUrl: './question-dialog.component.html',
  styleUrls: ['./question-dialog.component.css'],
  standalone: false,
  providers: [
    // このコンポーネントとその子要素専用のDateAdapterインスタンスを作成 //(0703)
    { provide: DateAdapter, useClass: NativeDateAdapter },
  ]
})
export class QuestionDialogComponent implements OnInit {

  projectId: string;
  //建物情報
  question?: ApiQuestion;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //建物情報フォーム
  questionFormGroup!: FormGroup;
  questionIdControl!: FormControl;
  displayNoControl!: FormControl;
  questionNamesControl!: FormControl;
  questionCompsControl!: FormControl;
  questionTypeControl!: FormControl;

  itemCheck01Control!: FormControl;
  itemCheck02Control!: FormControl;
  itemCheck03Control!: FormControl;
  itemCheck04Control!: FormControl;
  itemCheck05Control!: FormControl;
  itemCheck06Control!: FormControl;
  itemCheck07Control!: FormControl;
  itemCheck08Control!: FormControl;
  itemCheck09Control!: FormControl;
  itemCheck10Control!: FormControl;
  itemCheck11Control!: FormControl;

  itemCheckRangeLowerControl!: FormControl;
  itemCheckRangeUpperControl!: FormControl;

  itemCheckDateRangeLowerControl!: FormControl;
  itemCheckDateRangeUpperControl!: FormControl;

  itemCheckBaseDateControl!: FormControl;
  itemCheckBaseDateToStartControl!: FormControl;
  itemCheckBaseDateToEndControl!: FormControl;

  itemCheckColCountLowerControl!: FormControl;
  itemCheckColCountUpperControl!: FormControl;

  questionTypes = AppConst.QUESTION_ITEM_TYPES;

  projectBaseLang: string = 'ja';
  currentLang: string = 'ja';
  private langChangeSub!: Subscription; // TranslateServiceの購読を管理

  constructor(
    public dialogRef: MatDialogRef<QuestionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuestionDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private dateAdapter: DateAdapter<any>//(0703)
  ) {
    this.projectId = this.configurationService.getProjectId();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.currentLang = this.translate.currentLang; //(0703)
    // 1. コンポーネント初期化時に現在の言語でカレンダーを設定
    this.setCalendarLocale(this.currentLang);

    // 2. アプリケーションの言語が変更されたら、カレンダーの言語も動的に追従させる
    this.langChangeSub = this.translate.onLangChange.subscribe(event => {
      this.setCalendarLocale(event.lang);
    });

    this.question = this.data.question;
    if (!this.question) {
      this.question = {
        question_id: '',
        display_no: null as any,
        question_names: [],
        question_comps: null as any,
        question_type: '',
        question_select_items: [],
        question_check: [],
        question_check_range_upper: null as any,
        question_check_range_lower: null as any,
        question_check_date_range_upper: null as any,
        question_check_date_range_lower: null as any,
        question_check_base_date: null as any,
        question_check_base_date_to_start: null as any,
        question_check_base_date_to_end: null as any,
        question_check_col_count_upper: null as any,
        question_check_col_count_lower: null as any,
        project_id: this.projectId,
        enabled: true,
      };
      this.isAdded = true;
    }
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;

    this.createForm();
    this.questionIdControl = this.questionFormGroup.get('questionId') as FormControl;
    this.displayNoControl = this.questionFormGroup.get('displayNo') as FormControl;
    this.questionNamesControl = this.questionFormGroup.get('questionNames') as FormControl;
    this.questionCompsControl = this.questionFormGroup.get('questionComps') as FormControl;
    this.questionTypeControl = this.questionFormGroup.get('questionType') as FormControl;
    this.itemCheck01Control = this.questionFormGroup.get('itemCheck01') as FormControl;
    this.itemCheck02Control = this.questionFormGroup.get('itemCheck02') as FormControl;
    this.itemCheck03Control = this.questionFormGroup.get('itemCheck03') as FormControl;
    this.itemCheck04Control = this.questionFormGroup.get('itemCheck04') as FormControl;
    this.itemCheck05Control = this.questionFormGroup.get('itemCheck05') as FormControl;
    this.itemCheck06Control = this.questionFormGroup.get('itemCheck06') as FormControl;
    this.itemCheck07Control = this.questionFormGroup.get('itemCheck07') as FormControl;
    this.itemCheck08Control = this.questionFormGroup.get('itemCheck08') as FormControl;
    this.itemCheck09Control = this.questionFormGroup.get('itemCheck09') as FormControl;
    this.itemCheck10Control = this.questionFormGroup.get('itemCheck10') as FormControl;
    this.itemCheck11Control = this.questionFormGroup.get('itemCheck11') as FormControl;
    this.itemCheckRangeLowerControl = this.questionFormGroup.get('itemCheckRangeLower') as FormControl;
    this.itemCheckRangeUpperControl = this.questionFormGroup.get('itemCheckRangeUpper') as FormControl;
    this.itemCheckDateRangeLowerControl = this.questionFormGroup.get('itemCheckDateRangeLower') as FormControl;
    this.itemCheckDateRangeUpperControl = this.questionFormGroup.get('itemCheckDateRangeUpper') as FormControl;
    this.itemCheckBaseDateControl = this.questionFormGroup.get('itemCheckBaseDate') as FormControl;
    this.itemCheckBaseDateToStartControl = this.questionFormGroup.get('itemCheckBaseDateToStart') as FormControl;
    this.itemCheckBaseDateToEndControl = this.questionFormGroup.get('itemCheckBaseDateToEnd') as FormControl;
    this.itemCheckColCountLowerControl = this.questionFormGroup.get('itemCheckColCountLower') as FormControl;
    this.itemCheckColCountUpperControl = this.questionFormGroup.get('itemCheckColCountUpper') as FormControl;

    this.setCheckActivity(this.questionTypeControl.value);

  }

  ngAfterViewInit(): void {
  }

  /** //(0703)
  * Datepickerのロケールを設定するプライベートメソッド
  * @param lang 設定したい言語コード (例: 'en', 'ja')
  */
  private setCalendarLocale(lang: string): void {
    // 言語に応じたロケールを設定
    const locale = lang === 'en' ? 'en-US' : 'ja-JP';
    this.dateAdapter.setLocale(locale);
  }
  
  //以下、フォームの記入エラー表示
  public getErrorMessageToQuestionId() {
    return this.questionIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.questionIdControl.hasError('pattern')
          ? this.translate.instant('dialog.HALF_NUMERIC')
          : '';
  }

  public getErrorMessageTodisplayNo() {
    return this.displayNoControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToQuestionName() {
    return this.questionNamesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToQuestionComp() {
    return this.questionCompsControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    let itemCheck01 = false;
    let itemCheck02 = false;
    let itemCheck03 = false;
    let itemCheck04 = false;
    let itemCheck05 = false;
    let itemCheck06 = false;
    let itemCheck07 = false;
    let itemCheck08 = false;
    let itemCheck09 = false;
    let itemCheck10 = false;
    let itemCheck11 = false;
    if (!!this.question!.question_check && this.question!.question_check.length > 0) {
      for (const itemCheck of this.question!.question_check) {
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_REQUIRED) { itemCheck01 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_NUMBER) { itemCheck02 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC) { itemCheck03 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_FULL) { itemCheck04 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_FULL_KANA) { itemCheck05 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_FULL_HIRA) { itemCheck06 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_EMAIL) { itemCheck07 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_URL) { itemCheck08 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_TEL) { itemCheck09 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_RANGE) { itemCheck10 = true; }
        if (itemCheck == AppConst.QUESTION_ITEM_CHECK_COL_COUNT) { itemCheck11 = true; }
      }
    }


    this.questionFormGroup = this.formBuilder.group({
      questionId: [this.question!.question_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
      displayNo: [this.question!.display_no, [Validators.required]],
      questionNames: [this.question!.question_names, [Validators.required]],
      questionComps: [this.question!.question_comps, []],
      questionType: [this.question!.question_type, [Validators.required]],
      itemCheck01: [itemCheck01, []],
      itemCheck02: [itemCheck02, []],
      itemCheck03: [itemCheck03, []],
      itemCheck04: [itemCheck04, []],
      itemCheck05: [itemCheck05, []],
      itemCheck06: [itemCheck06, []],
      itemCheck07: [itemCheck07, []],
      itemCheck08: [itemCheck08, []],
      itemCheck09: [itemCheck09, []],
      itemCheck10: [itemCheck10, []],
      itemCheck11: [itemCheck11, []],
      itemCheckRangeLower: [this.question!.question_check_range_lower, []],
      itemCheckRangeUpper: [this.question!.question_check_range_upper, []],
      itemCheckDateRangeLower: [this.question!.question_check_date_range_lower, []],
      itemCheckDateRangeUpper: [this.question!.question_check_date_range_upper, []],
      itemCheckBaseDate: [this.question!.question_check_base_date, []],
      itemCheckBaseDateToStart: [this.question!.question_check_base_date_to_start, []],
      itemCheckBaseDateToEnd: [this.question!.question_check_base_date_to_end, []],
      itemCheckColCountLower: [this.question!.question_check_col_count_lower, []],
      itemCheckColCountUpper: [this.question!.question_check_col_count_upper, []]
    }, {
      validator: [this.rangeNumber, this.rangeDate, this.rangeColCount]
    });
  }

  //更新ボタン
  addQuestion(): void {
    if (this.questionFormGroup.valid) {
      this.question!.question_id = this.questionIdControl.value;
      this.question!.display_no = this.displayNoControl.value;
      this.question!.question_names = this.questionNamesControl.value;
      this.question!.question_comps = this.questionCompsControl.value;
      this.question!.question_type = this.questionTypeControl.value;
      //  選択肢
      if (this.question!.question_type !== 'select' && this.question!.question_type !== 'checkbox' && this.question!.question_type !== 'radio') {
        this.question!.question_select_items = [];
      } else {
        let error_flag = false;
        for (const question_select_item of this.question!.question_select_items) {
          if (question_select_item.items.length > 0) {
            if (!question_select_item.items[0].item || question_select_item.items[0].item == '') {
              error_flag = true;
            }
            if (!question_select_item.value || question_select_item.value == '') {
              error_flag = true;
            }
          } else {
            error_flag = true;
          }
        }
        if (!!error_flag) {
          alert(this.translate.instant('選択肢の入力に誤りがあります。'));
          return;
        }

      }
      //  チェック項目
      this.question!.question_check = [];
      if (this.itemCheck01Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_REQUIRED); }
      if (this.itemCheck02Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_NUMBER); }
      if (this.itemCheck03Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC); }
      if (this.itemCheck04Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_FULL); }
      if (this.itemCheck05Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_FULL_KANA); }
      if (this.itemCheck06Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_FULL_HIRA); }
      if (this.itemCheck07Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_EMAIL); }
      if (this.itemCheck08Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_URL); }
      if (this.itemCheck09Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_TEL); }
      if (this.itemCheck10Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_RANGE); }
      if (this.itemCheck11Control!.value) { this.question!.question_check.push(AppConst.QUESTION_ITEM_CHECK_COL_COUNT); }
      //  範囲チェック未選択時はクリア
      this.question!.question_check_range_upper = null as any;
      this.question!.question_check_range_lower = null as any;
      this.question!.question_check_date_range_upper = null as any;
      this.question!.question_check_date_range_lower = null as any;
      this.question!.question_check_base_date = null as any;
      this.question!.question_check_base_date_to_start = null as any;
      this.question!.question_check_base_date_to_end = null as any;
      if (!!this.itemCheck10Control!.value) {
        if (this.question!.question_type === AppConst.QUESTION_ITEM_TYPE_NUMBER) {
          this.question!.question_check_range_upper = this.itemCheckRangeUpperControl.value ? this.itemCheckRangeUpperControl.value : null;
          this.question!.question_check_range_lower = this.itemCheckRangeLowerControl.value ? this.itemCheckRangeLowerControl.value : null;
        } else if (this.question!.question_type === AppConst.QUESTION_ITEM_TYPE_DATE) {
          this.question!.question_check_date_range_upper = this.itemCheckDateRangeUpperControl.value ? this.itemCheckDateRangeUpperControl.value : null;
          this.question!.question_check_date_range_lower = this.itemCheckDateRangeLowerControl.value ? this.itemCheckDateRangeLowerControl.value : null;
          this.question!.question_check_base_date = this.itemCheckBaseDateControl.value ? this.itemCheckBaseDateControl.value : null;
          this.question!.question_check_base_date_to_start = this.itemCheckBaseDateToStartControl.value ? this.itemCheckBaseDateToStartControl.value : null;
          this.question!.question_check_base_date_to_end = this.itemCheckBaseDateToEndControl.value ? this.itemCheckBaseDateToEndControl.value : null;
        } else if (this.question!.question_type === AppConst.QUESTION_ITEM_TYPE_DATETIME) {
          this.question!.question_check_date_range_upper = this.itemCheckDateRangeUpperControl.value ? this.itemCheckDateRangeUpperControl.value : null;
          this.question!.question_check_date_range_lower = this.itemCheckDateRangeLowerControl.value ? this.itemCheckDateRangeLowerControl.value : null;
        }
      }
      //  文字数チェック未選択時はクリア
      this.question!.question_check_col_count_upper = null as any;
      this.question!.question_check_col_count_lower = null as any;
      if (!!this.itemCheck11Control!.value) {
        this.question!.question_check_col_count_upper = this.itemCheckColCountUpperControl.value ? this.itemCheckColCountUpperControl.value : null;
        this.question!.question_check_col_count_lower = this.itemCheckColCountLowerControl.value ? this.itemCheckColCountLowerControl.value : null;
      }
      if (this.question) {
        let request: ApiSetQuestionsRequest = {
          access_token: '',
          change_type: this.data.change_type,
          questions: [this.question]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setQuestions(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //取消ボタン
  onNoClick(): void {
    this.dialogRef.close();
  }

  //項目名ダイアログ
  openQuestionNameDialog(): void {
    const dialogRef = this.dialog.open(MultiQnameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.question!.question_names }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.question!.question_names = result;
        this.questionNamesControl.setValue(this.question!.question_names);
      }
    });
  }

  //補足文章ダイアログ
  openQuestionCompDialog(): void {
    const dialogRef = this.dialog.open(MultiQcompDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { comps: this.question!.question_comps }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.question!.question_comps = result;
        this.questionCompsControl.setValue(this.question!.question_comps);
      }
    });
  }

  //選択肢ダイアログ
  openQuestionItemDialog(index: number): void {
    const dialogRef = this.dialog.open(MultiQitemDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { items: this.question!.question_select_items[index].items }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.question!.question_select_items![index].items = result;
      }
    });
  }

  onSelectValueChange(event: any, index: number): void {
    this.question!.question_select_items![index].value = event.target.value;
  }

  //選択肢追加ボタン
  appendClick(): void {
    this.question!.question_select_items!.push({
      items: [],
      value: '',
      // related_display_flag: false,
      // related_campaign_item: null
    });
  }

  //選択肢削除ボタン
  deleteClick(index: number): void {
    this.question!.question_select_items!.splice(index, 1);
  }

  //選択肢並べ替え
  onDropSelectItem(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.question!.question_select_items, event.previousIndex, event.currentIndex);
  }

  // 編集の初期表示時にチェックの活性を反映
  setCheckActivity(itemType: string) {
    this.itemCheck01Control.enable(); // 必須
    this.itemCheck02Control.enable(); // 数値
    this.itemCheck03Control.enable(); // 半角英数
    this.itemCheck04Control.enable(); // 全角
    this.itemCheck05Control.enable(); // 全角カナ
    this.itemCheck06Control.enable(); // 全角かな
    this.itemCheck07Control.enable(); // メアド
    this.itemCheck08Control.enable(); // URL
    this.itemCheck09Control.enable(); // 電話番号
    this.itemCheck10Control.enable(); // 範囲
    this.itemCheck11Control.enable(); // 文字数
    if (itemType == AppConst.QUESTION_ITEM_TYPE_STRING) {
      this.itemCheck02Control.disable();
      this.itemCheck10Control.disable();
    } else if (itemType == AppConst.QUESTION_ITEM_TYPE_TEXTAREA) {
      this.itemCheck02Control.disable();
      this.itemCheck07Control.disable();
      this.itemCheck08Control.disable();
      this.itemCheck09Control.disable();
      this.itemCheck10Control.disable();
    } else if (itemType == AppConst.QUESTION_ITEM_TYPE_NUMBER) {
      this.itemCheck03Control.disable();
      this.itemCheck04Control.disable();
      this.itemCheck05Control.disable();
      this.itemCheck06Control.disable();
      this.itemCheck07Control.disable();
      this.itemCheck08Control.disable();
      this.itemCheck09Control.disable();
      this.itemCheck11Control.disable();
    } else if (itemType == AppConst.QUESTION_ITEM_TYPE_RADIO) {
      this.itemCheck01Control.disable();
      this.itemCheck02Control.disable();
      this.itemCheck03Control.disable();
      this.itemCheck04Control.disable();
      this.itemCheck05Control.disable();
      this.itemCheck06Control.disable();
      this.itemCheck07Control.disable();
      this.itemCheck08Control.disable();
      this.itemCheck09Control.disable();
      this.itemCheck10Control.disable();
      this.itemCheck11Control.disable();
    } else if (itemType == AppConst.QUESTION_ITEM_TYPE_DATE || itemType == AppConst.QUESTION_ITEM_TYPE_DATETIME) {
      this.itemCheck02Control.disable();
      this.itemCheck03Control.disable();
      this.itemCheck04Control.disable();
      this.itemCheck05Control.disable();
      this.itemCheck06Control.disable();
      this.itemCheck07Control.disable();
      this.itemCheck08Control.disable();
      this.itemCheck09Control.disable();
      this.itemCheck11Control.disable();
    } else {
      this.itemCheck02Control.disable();
      this.itemCheck03Control.disable();
      this.itemCheck04Control.disable();
      this.itemCheck05Control.disable();
      this.itemCheck06Control.disable();
      this.itemCheck07Control.disable();
      this.itemCheck08Control.disable();
      this.itemCheck09Control.disable();
      this.itemCheck10Control.disable();
      this.itemCheck11Control.disable();
    }
    // 編集対象に設定されているバリデーション項目に対応した活性制御を実行
    for (const code of this.question!.question_check) {
      this.checkToggle(code, { checked: true });
    }
  }

  //項目タイプ変更時
  onQuestionTypeChange(event: any) {
    this.itemCheck01Control.enable();                                                               //  必須
    this.itemCheck02Control.enable();                                                               //  数値
    this.itemCheck03Control.enable();                                                               //  半角英数
    this.itemCheck04Control.enable();                                                               //  全角
    this.itemCheck05Control.enable();                                                               //  全角カナ
    this.itemCheck06Control.enable();                                                               //  全角かな
    this.itemCheck07Control.enable();                                                               //  メアド
    this.itemCheck08Control.enable();                                                               //  URL
    this.itemCheck09Control.enable();                                                               //  電話番号
    this.itemCheck10Control.enable();                                                               //  範囲
    this.itemCheck11Control.enable();                                                               //  文字数
    if (event.value == AppConst.QUESTION_ITEM_TYPE_STRING) {
      this.itemCheck02Control.setValue(false); this.itemCheck02Control.disable();
      this.itemCheck10Control.setValue(false); this.itemCheck10Control.disable();
      // チェック解除
      this.itemCheck03Control.setValue(false);
      this.itemCheck04Control.setValue(false);
      this.itemCheck05Control.setValue(false);
      this.itemCheck06Control.setValue(false);
      this.itemCheck07Control.setValue(false);
      this.itemCheck08Control.setValue(false);
      this.itemCheck09Control.setValue(false);
      this.itemCheck11Control.setValue(false);
    } else if (event.value == AppConst.QUESTION_ITEM_TYPE_TEXTAREA) {
      this.itemCheck02Control.setValue(false); this.itemCheck02Control.disable();
      this.itemCheck07Control.setValue(false); this.itemCheck07Control.disable();
      this.itemCheck08Control.setValue(false); this.itemCheck08Control.disable();
      this.itemCheck09Control.setValue(false); this.itemCheck09Control.disable();
      this.itemCheck10Control.setValue(false); this.itemCheck10Control.disable();
      // チェック解除
      this.itemCheck03Control.setValue(false);
      this.itemCheck04Control.setValue(false);
      this.itemCheck05Control.setValue(false);
      this.itemCheck06Control.setValue(false);
      this.itemCheck11Control.setValue(false);
    } else if (event.value == AppConst.QUESTION_ITEM_TYPE_NUMBER) {
      this.itemCheck03Control.setValue(false); this.itemCheck03Control.disable();
      this.itemCheck04Control.setValue(false); this.itemCheck04Control.disable();
      this.itemCheck05Control.setValue(false); this.itemCheck05Control.disable();
      this.itemCheck06Control.setValue(false); this.itemCheck06Control.disable();
      this.itemCheck07Control.setValue(false); this.itemCheck07Control.disable();
      this.itemCheck08Control.setValue(false); this.itemCheck08Control.disable();
      this.itemCheck09Control.setValue(false); this.itemCheck09Control.disable();
      this.itemCheck11Control.setValue(false); this.itemCheck11Control.disable();
    } else if (event.value == AppConst.QUESTION_ITEM_TYPE_RADIO) {
      this.itemCheck01Control.setValue(true); this.itemCheck01Control.disable();
      this.itemCheck02Control.setValue(false); this.itemCheck02Control.disable();
      this.itemCheck03Control.setValue(false); this.itemCheck03Control.disable();
      this.itemCheck04Control.setValue(false); this.itemCheck04Control.disable();
      this.itemCheck05Control.setValue(false); this.itemCheck05Control.disable();
      this.itemCheck06Control.setValue(false); this.itemCheck06Control.disable();
      this.itemCheck07Control.setValue(false); this.itemCheck07Control.disable();
      this.itemCheck08Control.setValue(false); this.itemCheck08Control.disable();
      this.itemCheck09Control.setValue(false); this.itemCheck09Control.disable();
      this.itemCheck10Control.setValue(false); this.itemCheck10Control.disable();
      this.itemCheck11Control.setValue(false); this.itemCheck11Control.disable();
    } else if (event.value == AppConst.QUESTION_ITEM_TYPE_DATE || event.value == AppConst.QUESTION_ITEM_TYPE_DATETIME) {
      this.itemCheck02Control.setValue(false); this.itemCheck02Control.disable();
      this.itemCheck03Control.setValue(false); this.itemCheck03Control.disable();
      this.itemCheck04Control.setValue(false); this.itemCheck04Control.disable();
      this.itemCheck05Control.setValue(false); this.itemCheck05Control.disable();
      this.itemCheck06Control.setValue(false); this.itemCheck06Control.disable();
      this.itemCheck07Control.setValue(false); this.itemCheck07Control.disable();
      this.itemCheck08Control.setValue(false); this.itemCheck08Control.disable();
      this.itemCheck09Control.setValue(false); this.itemCheck09Control.disable();
      this.itemCheck11Control.setValue(false); this.itemCheck11Control.disable();
    } else {
      this.itemCheck02Control.setValue(false); this.itemCheck02Control.disable();
      this.itemCheck03Control.setValue(false); this.itemCheck03Control.disable();
      this.itemCheck04Control.setValue(false); this.itemCheck04Control.disable();
      this.itemCheck05Control.setValue(false); this.itemCheck05Control.disable();
      this.itemCheck06Control.setValue(false); this.itemCheck06Control.disable();
      this.itemCheck07Control.setValue(false); this.itemCheck07Control.disable();
      this.itemCheck08Control.setValue(false); this.itemCheck08Control.disable();
      this.itemCheck09Control.setValue(false); this.itemCheck09Control.disable();
      this.itemCheck10Control.setValue(false); this.itemCheck10Control.disable();
      this.itemCheck11Control.setValue(false); this.itemCheck11Control.disable();
    }
    // 範囲指定、文字数指定系の項目クリア
    this.itemCheckRangeLowerControl.setValue(null);
    this.itemCheckRangeUpperControl.setValue(null);
    this.itemCheckDateRangeLowerControl.setValue(null);
    this.itemCheckDateRangeUpperControl.setValue(null);
    this.itemCheckBaseDateControl.setValue(null);
    this.itemCheckBaseDateToStartControl.setValue(null);
    this.itemCheckBaseDateToEndControl.setValue(null);
    this.itemCheckColCountLowerControl.setValue(null);
    this.itemCheckColCountUpperControl.setValue(null);
  }

  //チェック項目変更時
  checkToggle(checkId: string, event: MatCheckboxChange | { checked: boolean }) {
    const questionType = this.questionTypeControl.value;
    if (questionType == AppConst.QUESTION_ITEM_TYPE_STRING) {                                       //  string
      if (event.checked) {                                                                          //    TRUE にされたとき、共存できないチェック項目を全て非活性(disable)にする
        if (checkId == AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC) {                            //      半角英数
          this.itemCheck04Control.disable();                                                        //        全角
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck06Control.disable();                                                        //        全角かな
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck08Control.disable();                                                        //        URL
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL) {                                  //      全角
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck08Control.disable();                                                        //        URL
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_KANA) {                             //      全角カナ
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck06Control.disable();                                                        //        全角かな
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck08Control.disable();                                                        //        URL
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_HIRA) {                             //      全角かな
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck08Control.disable();                                                        //        URL
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_EMAIL) {                                 //      メールアドレス
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck04Control.disable();                                                        //        全角
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck06Control.disable();                                                        //        全角かな
          this.itemCheck08Control.disable();                                                        //        URL
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_URL) {                                   //      URL
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck04Control.disable();                                                        //        全角
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck06Control.disable();                                                        //        全角かな
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck09Control.disable();                                                        //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_TEL) {                                   //      電話番号
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck04Control.disable();                                                        //        全角
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck06Control.disable();                                                        //        全角かな
          this.itemCheck07Control.disable();                                                        //        メールアドレス
          this.itemCheck08Control.disable();                                                        //        URL
        } else {                                                                                    //      必須/数値/範囲 の活性制御はしない
        }                                                                                           //
      } else {                                                                                      //    FALSE にされたとき、共存できないチェック項目を全て活性(enable)にする
        if (checkId == AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC) {                            //      半角英数
          this.itemCheck04Control.enable();                                                         //        全角
          this.itemCheck05Control.enable();                                                         //        全角カナ
          this.itemCheck06Control.enable();                                                         //        全角かな
          this.itemCheck07Control.enable();                                                         //        メールアドレス
          this.itemCheck08Control.enable();                                                         //        URL
          this.itemCheck09Control.enable();                                                         //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL) {                                  //      全角
          if (!this.itemCheck05Control.value && !this.itemCheck06Control.value) {                   //        全角カナ or 全角かな が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
            this.itemCheck07Control.enable();                                                       //          メールアドレス
            this.itemCheck08Control.enable();                                                       //          URL
            this.itemCheck09Control.enable();                                                       //          電話番号
          }                                                                                         //
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_KANA) {                             //      全角カナ
          if (!this.itemCheck04Control.value) {                                                     //        全角 が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
            this.itemCheck06Control.enable();                                                       //          全角かな
            this.itemCheck07Control.enable();                                                       //          メールアドレス
            this.itemCheck08Control.enable();                                                       //          URL
            this.itemCheck09Control.enable();                                                       //          電話番号
          } else {                                                                                  //        全角 が同時に選択されている場合
            this.itemCheck06Control.enable();                                                       //          全角かな
          }                                                                                         //
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_HIRA) {                             //      全角かな
          if (!this.itemCheck04Control.value) {                                                     //        全角 が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
            this.itemCheck05Control.enable();                                                       //          全角カナ
            this.itemCheck07Control.enable();                                                       //          メールアドレス
            this.itemCheck08Control.enable();                                                       //          URL
            this.itemCheck09Control.enable();                                                       //          電話番号
          } else {                                                                                  //        全角 が同時に選択されている場合
            this.itemCheck05Control.enable();                                                       //          全角カナ
          }                                                                                         //
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_EMAIL) {                                 //      メールアドレス
          this.itemCheck03Control.enable();                                                         //        半角英数
          this.itemCheck04Control.enable();                                                         //        全角
          this.itemCheck05Control.enable();                                                         //        全角カナ
          this.itemCheck06Control.enable();                                                         //        全角かな
          this.itemCheck08Control.enable();                                                         //        URL
          this.itemCheck09Control.enable();                                                         //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_URL) {                                   //      URL
          this.itemCheck03Control.enable();                                                         //        半角英数
          this.itemCheck04Control.enable();                                                         //        全角
          this.itemCheck05Control.enable();                                                         //        全角カナ
          this.itemCheck06Control.enable();                                                         //        全角かな
          this.itemCheck07Control.enable();                                                         //        メールアドレス
          this.itemCheck09Control.enable();                                                         //        電話番号
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_TEL) {                                    //      電話番号
          this.itemCheck03Control.enable();                                                         //        半角英数
          this.itemCheck04Control.enable();                                                         //        全角
          this.itemCheck05Control.enable();                                                         //        全角カナ
          this.itemCheck06Control.enable();                                                         //        全角かな
          this.itemCheck07Control.enable();                                                         //        メールアドレス
          this.itemCheck08Control.enable();                                                         //        URL
        } else {                                                                                    //      必須/数値/範囲 の活性制御はしない（入ってこないと思うが）
        }                                                                                           //
      }                                                                                             //
    } else if (questionType == AppConst.QUESTION_ITEM_TYPE_TEXTAREA) {                              //  text-area
      if (event.checked) {                                                                          //    TRUE にされたとき、共存できないチェック項目を全て非活性(disable)にする
        if (checkId == AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC) {                            //      半角英数
          this.itemCheck04Control.disable();                                                        //        全角
          this.itemCheck05Control.disable();                                                        //        全角カナ
          this.itemCheck06Control.disable();                                                        //        全角かな
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL) {                                  //      全角
          this.itemCheck03Control.disable();                                                        //        半角英数
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_KANA) {                             //      全角カナ
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck06Control.disable();                                                        //        全角かな
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_HIRA) {                             //      全角かな
          this.itemCheck03Control.disable();                                                        //        半角英数
          this.itemCheck05Control.disable();                                                        //        全角カナ
        } else {                                                                                    //      必須/数値/メールアドレス/URL/電話番号/範囲 は活性制御しない
        }                                                                                           //
      } else {                                                                                      //    FALSE にされたとき、共存できないチェック項目を全て活性(enable)にする
        if (checkId == AppConst.QUESTION_ITEM_CHECK_HALF_ALPHANUMERIC) {                            //      半角英数
          this.itemCheck04Control.enable();                                                         //        全角
          this.itemCheck05Control.enable();                                                         //        全角カナ
          this.itemCheck06Control.enable();                                                         //        全角かな
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL) {                                  //      全角
          if (!this.itemCheck05Control.value && !this.itemCheck06Control.value) {                   //        全角カナ or 全角かな が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
          }                                                                                         //
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_KANA) {                             //      全角カナ
          if (!this.itemCheck04Control.value) {                                                     //        全角 が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
            this.itemCheck06Control.enable();                                                       //          全角かな
          } else {                                                                                  //        全角 が同時に選択されている場合
            this.itemCheck06Control.enable();                                                       //          全角かな
          }                                                                                         //
        } else if (checkId == AppConst.QUESTION_ITEM_CHECK_FULL_HIRA) {                             //      全角かな
          if (!this.itemCheck04Control.value) {                                                     //        全角 が同時に選択されていない場合
            this.itemCheck03Control.enable();                                                       //          半角英数
            this.itemCheck05Control.enable();                                                       //          全角カナ
          } else {                                                                                  //        全角 が同時に選択されている場合
            this.itemCheck05Control.enable();                                                       //          全角かな
          }                                                                                         //
        } else {                                                                                    //      必須/数値/メールアドレス/URL/電話番号/範囲 は活性制御しない（入ってこないと思うが）
        }                                                                                           //
      }                                                                                             //
    } else {                                                                                        //  現状 string/text-area 以外の活性制御は必要ない
    }                                                                                               //
  }

  clearCheckDateRangeLower(): void {
    this.itemCheckDateRangeLowerControl.setValue(null);
  }

  clearCheckDateRangeUpper(): void {
    this.itemCheckDateRangeUpperControl.setValue(null);
  }

  clearCheckBaseDate(): void {
    this.itemCheckBaseDateControl.setValue(null);
  }

  rangeNumber(ac: AbstractControl) {
    const check = ac.get('itemCheck10');
    const lower = ac.get('itemCheckRangeLower');
    const upper = ac.get('itemCheckRangeUpper');
    if (!!check && !!lower && !!upper) {
      lower.setErrors(null);
      upper.setErrors(null);
      if (check.value && lower.value > upper.value && lower.value != null && upper.value != null) {
        lower.setErrors({ rangeNumber: true });
        upper.setErrors({ rangeNumber: true });
      }
    }
  }

  rangeDate(ac: AbstractControl) {
    const check = ac.get('itemCheck10');
    const lower = ac.get('itemCheckDateRangeLower');
    const upper = ac.get('itemCheckDateRangeUpper');
    if (!!check && !!lower && !!upper) {
      lower.setErrors(null);
      upper.setErrors(null);
      if (check.value && lower.value > upper.value && lower.value != null && upper.value != null) {
        lower.setErrors({ rangeDate: true });
        upper.setErrors({ rangeDate: true });
      }
    }
  }

  rangeColCount(ac: AbstractControl) {
    const check = ac.get('itemCheck11');
    const lower = ac.get('itemCheckColCountLower');
    const upper = ac.get('itemCheckColCountUpper');
    if (!!check && !!lower && !!upper) {
      lower.setErrors(null);
      upper.setErrors(null);
      if (check.value && lower.value > upper.value && lower.value != null && upper.value != null) {
        lower.setErrors({ rangeColCount: true });
        upper.setErrors({ rangeColCount: true });
      }
    }
  }

}
